<!--  -->
<template>
  <div class=''>
    <HeadView :title="headTitle"
              :content="headContent"
              :imgPath="headImgPath" />

    <div class="service__option--wrap">
      <div class="service__option__item--wrap"
           @click="chooseItem(0)">
        <img src="../../images/hyfw.png"
             alt=""
             class="item__img"
             :class="{'item__img--choose':chooseIndex==0}">
        <span class="service__option__title"
              :class="{'service__option__title--choose':chooseIndex==0}">核验服务</span>
      </div>
      <div class="service__option__item--wrap mg-l-160"
           @click="chooseItem(1)">
        <img src="../../images/hyyy.png"
             alt=""
             class="item__img"
             :class="{'item__img--choose':chooseIndex==1}">
        <span class="service__option__title "
              :class="{'service__option__title--choose':chooseIndex==1}">核验预约</span>
      </div>
      <div class="service__option__item--wrap mg-l-160"
           @click="chooseItem(2)">
        <img src="../../images/flfg.png"
             alt=""
             class="item__img"
             :class="{'item__img--choose':chooseIndex==2}">
        <span class="service__option__title"
              :class="{'service__option__title--choose':chooseIndex==2}">法律法规</span>
      </div>

    </div>
    <div class="service__item__content--wrap">
      <div v-if="chooseIndex ==0">
        <p class="service__item__content__title">尊敬的广州商事登记“市民签”用户：</p>
        <p class="service__item__content">{{ hyfwContent }}</p>
        <p class="service__item__time">2023-10-20</p>
      </div>
      <div v-if="chooseIndex == 1"
           style="display: flex;flex-direction:column;align-items:center;justify-content:center;width:100%;">
        <img src="../../images/gzh_qr.png"
             alt=""
             style="width: 240px;height:240px;margin-top:20px;">
        <span class="service__item__address">GDCA受理点地址：广州市白云区同和街同沙路283号之二2009号B1751房</span>
      </div>
      <div v-if="chooseIndex ==2">
        <p class="service__item__content__title">尊敬的广州商事登记“市民签”用户：</p>
        <p class="service__item__content">{{ flfgContent }}</p>

      </div>
    </div>
    <foot-view></foot-view>
  </div>
</template>

<script>
import HeadView from '@/components/Head/Head.vue'
export default {
  name: 'ServiceView',
  components: { HeadView },
  data () {
    return {
      headTitle: '服务中心',
      headContent: '致力于为客户提供高效、安全、可靠的电子认证服务。',
      headImgPath: require('../../images/fwzx.png'),
      chooseIndex: 0,
      hyfwContent: '根据《工业和信息化部办公厅关于开展电子认证服务合规性专项整治工作的通知》（工信厅信发函〔2022〕183号）、《网络安全管理条例》及《电子认证服务管理办法》第二十一条规定，按照数安时代科技股份有限公司（简称GDCA）针对《广州市全程电子化商事登记实施办法》风险控制要求，为了强化手机“市民签”数字证书风险控制，将对数字用户在“市民签”申请、使用等方面加强身份认证鉴别安全管控和使用风险提醒工作。如用户在短时间内重复频繁调用手机刷脸或数字签名等“市民签”服务时，可能会触发GDCA的数字签名使用安全保护机制，用户将即时暂停“市民签”操作。如用户出现“市民签”无法签名或签名失败提示，请本人携带身份证原件及身份证正反面复印件至GDCA指定受理点进行现场核验。用户本人需要现场提交纸质资料，并完整学习GDCA关于数字签名风险安全管理宣传视频，当天提交的申请资料在3-5个工作日内完成审核，审核通过后将恢复手机“市民签”服务。恢复“市民签”服务后用户如继续存在频繁进行签名操作，可能会再次触发风控机制暂停使用“市民签”服务。',
      flfgContent: '根据《工业和信息化部办公厅关于开展电子认证服务合规性专项整治工作的通知》（工信厅信发函〔2022〕183号）\n1、为了加强内部的合规性控制，将对数字使用申请、使用等方面加强安全管控。请带齐相关资料，至我司现场完成身份核验，了解《电子认证服务管理办法》第二十一条规定之事项，并明确双方的权力和义务。第二十一条 电子认证服务机构在受理电子签名认证证书申请前，应当向申请人告知下列事项:\n(一)电子签名认证证书和电子签名的使用条件。\n(二)服务收费的项目和标准。\n(三)保存和使用证书持有人信息的权限和责任。\n(四)电子认证服务机构的责任范围。\n(五)证书持有人的责任范围。\n(六)其他需要事先告知的事项。\n2、具体需要带起相关资料，进行现场身份核验。\n3、是否会再次触发风控，需要根据使用场景由模型自动判断。'
    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {
    chooseItem (index) {
      this.chooseIndex = index
    }
  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.service__option--wrap {
  height: 232px;
  padding: 0 360px;
  display: flex;
  align-items: center;
  width: 100%;

  .service__option__item--wrap {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item__img {
      width: 64px;
      height: 64px;
      opacity: 0.5;
      &:hover {
        opacity: 1;
      }
    }
    .item__img--choose {
      width: 64px;
      height: 64px;
      opacity: 1;
    }
    .service__option__title {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0px;
      margin-top: 16px;
      color: #666666;
    }
    .service__option__title--choose {
      color: $color-primary;
    }
  }
}
.service__item__content--wrap {
  height: 500px;
  padding: 0 360px;
  padding-bottom: 60px;
  box-sizing: border-box;
  padding-top: 60px;
  background-color: #f5f7fa;
  overflow: ao;
  .service__item__content__title {
    font-weight: bold;
    font-size: 20px;
    color: #666666;
  }
  .service__item__content {
    font-size: 16px;
    color: #666666;
  }
  .service__item__time {
    font-size: 16px;
    color: #666666;
    text-align: right;
    margin-top: 72px;
  }
  .service__item__address {
    font-size: 16px;
    color: #666666;
    margin-top: 40px;
  }
}
.mg-l-160 {
  margin-left: 160px;
}
</style>
